"use strict";
class AppWiser extends HTMLElement {
    constructor(){
        super();
        const wiserSection = document.querySelector('wiser-section');
        if(!wiserSection) return;
        //this.watchVisibility();
        this.addScriptToDOM();
    }

    static getElementName(){
        return 'wiser-section'
    }

    watchVisibility = () => {
        let viewportHeight = Math.floor((window.innerHeight*40)/100) + 'px';
        const config = {
            root: null,
            rootMargin: `0px 0px -${viewportHeight}px 0px`,
            threshold: 0.05
        };

        const observer = new IntersectionObserver((entries, observer) => {
            if(entries[0].isIntersecting){
                const section = entries[0].target;
                this.addScriptToDOM();

                setTimeout(() => {
                    const skeltonScreen = this.querySelector('[data-skelton-screen]');
                    if(skeltonScreen) skeltonScreen.remove();
                }, 6000);

                setTimeout(this.tweakReviewLayout.bind(this), 3000);
                setTimeout(this.tweakReviewLayout.bind(this), 4000);
                observer.unobserve(section);
            }
        }, config);

        observer.observe(this);
    }

    addScriptToDOM = () => {
        setTimeout(() => {
            const skeltonScreen = this.querySelector('[data-skelton-screen]');
            if(skeltonScreen) skeltonScreen.remove();
        }, 3000);

        if(!_theme.wiserScripts || _theme.wiserScripts.length === 0) return;
        const wiserScripts = _theme.wiserScripts;
        delete _theme.wiserScripts;

        function appendScript(scripts) {
            if(scripts.length === 0) return;

            const script = scripts.shift();
            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.defer = 'defer'; // s.async = true;
            s.src = script.url;
    
            if(script.attributes && script.attributes.length > 0){
                script.attributes.forEach(attr => {
                    s.setAttribute(attr.key, attr.value);
                });
            }
            const x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);

            s.onload = function(){
                appendScript(scripts);
            }
        }

        appendScript(wiserScripts);
        setTimeout(this.tweakReviewLayout.bind(this), 2000);
    }

    tweakReviewLayout = () => {
        const reviewElems = this.querySelectorAll('.ws-card__header [data-bv-show="inline_rating"]');
        if(reviewElems.length === 0) return;

        reviewElems.forEach(elem => {
            const parent = elem.querySelector('.bv_numReviews_component_container');
            const countMeta = elem.querySelector('.bv_numReviews_component_container meta');
            if(!parent || !countMeta) return;
            const count = countMeta.getAttribute('content');
            parent.append(count);
        });
    }
}

if(!customElements.get(AppWiser.getElementName())){
    customElements.define(AppWiser.getElementName(), AppWiser);
}